import { useEffect, useState } from "react";
import { Form, Tabs, Tab } from "react-bootstrap";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Loader from "../components/Loader";
import axios from "axios";
import { BASE_URL, CMS_CONTENT } from "../API";
import { toast } from "react-toastify";
import { FaArrowUp, FaArrowDown, FaTrash, FaPlus } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link", "clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
];

function CmsManagement() {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("privacy");
  const [privacyPolicy, setPrivacyPolicy] = useState([]);
  const [termsConditions, setTermsConditions] = useState([]);
  const [faq, setFaq] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [about, setAbout] = useState({});
  const [preview, setPreview] = useState(null);
  const [feature, setFeature] = useState([]);
  const TOKEN = localStorage.getItem("token");
  const headers = { token: TOKEN };

  useEffect(() => { fetchCmsData() }, []);

  const fetchCmsData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BASE_URL + CMS_CONTENT, { headers });
      const json = response.data;
      if (json.status === true && json.data) {
        setPrivacyPolicy(json.data.privacyPolicy || "");
        setTermsConditions(json.data.termsConditions || "");
        setFaq(json.data.faq || []);
        setReviews(json.data.review || []);
        setAbout({
          heading: json.data?.about?.heading || "",
          description: json.data?.about?.description || "",
          image: json.data?.about?.image || null,
        });
        setPreview(json.data?.about?.image || null);
        setFeature(json.data.feature || []);
      }
      else { toast.error("Failed to load CMS content.") }
    } catch (err) {
      console.error("Error fetching CMS data:", err);
      toast.error(err?.response?.data?.error_description || "Error fetching CMS data.");
    }
    finally { setIsLoading(false) }
  };

  const handleSavePolicy = async (type) => {
    setIsLoading(true);
    try {
      const payload = {};
      if (type === "privacy") { payload.privacyPolicy = privacyPolicy }
      else if (type === "terms") { payload.termsConditions = termsConditions }

      const response = await axios.put(BASE_URL + CMS_CONTENT, payload, { headers });
      if (response.data.status) { toast.success(`${type === "privacy" ? "Privacy Policy" : "Terms & Conditions"} saved successfully!`) }
      else { toast.error("Failed to save content.") }
    }
    catch (err) { toast.error(err?.response?.data?.error_description || "Something went wrong.") }
    finally { setIsLoading(false) }
  };

  const handleSave = async (type) => {
    if (type === "faq") {
      for (let i = 0; i < faq.length; i++) {
        if (!faq[i].question.trim() || !faq[i].answer.trim()) { toast.warn("FAQ question and answer cannot be empty."); return }
      }
    }

    if (type === "review") {
      for (let i = 0; i < reviews.length; i++) {
        if (!reviews[i].review.trim() || !reviews[i].author.trim() || !reviews[i].address.trim()) { toast.warn("Review, author and address cannot be empty."); return }
      }
    }

    if (type === "about") {
      if (!about.heading?.trim()) { toast.warn("Heading is required."); return }
      if (!about.description?.trim()) { toast.warn("Description is required."); return }
    }

    if (type === "feature") {
      for (let i = 0; i < feature.length; i++) {
        if (!feature[i].title.trim()) { toast.warn("Feature cannot be empty."); return }
      }
    }

    setIsLoading(true);
    try {
      let payload;
      let config = { headers };
      const formData = new FormData();
      if (type === "faq") { payload = { faq } }
      else if (type === "review") { payload = { review: reviews } }
      else if (type === "feature") { payload = { feature } }
      else if (type === "about") {
        formData.append("about", JSON.stringify({ heading: about.heading, description: about.description, }));
        if (about.image instanceof File) { formData.append("image", about.image) }
        config = { headers: { ...headers, "Content-Type": "multipart/form-data" }, };
      }
      const response = await axios.put(BASE_URL + CMS_CONTENT, type === 'about' ? formData : payload, config);
      if (response.data.status) {
        toast.success(
          type === "faq" ? "FAQs updated successfully!" :
            type === "review" ? "Reviews updated successfully!" :
              type === "feature" ? "Features updated successfully!" : "About section updated successfully!"
        );
      }
      else { toast.error(type === "faq" ? "Failed to update FAQs." : "Failed to update reviews."); }
    }
    catch (err) { toast.error(err?.response?.data?.error_description || "Something went wrong.") }
    finally { setIsLoading(false); }
  };

  const handleAdd = (type) => {
    if (type === 'faq') { setFaq([...faq, { question: "", answer: "" }]) }
    else if (type === "feature") { setFeature([...feature, { title: "" }]) }
    else { setReviews([...reviews, { review: "", author: "", address: "" }]) }
  };

  const handleChange = (index, field, value, type) => {
    if (type === 'faq') {
      const newFaq = [...faq];
      newFaq[index][field] = value;
      setFaq(newFaq);
    }
    if (type === 'review') {
      const newReview = [...reviews];
      newReview[index][field] = value;
      setReviews(newReview);
    }
  };

  const handleDelete = (index, type) => {
    if (type === 'faq') {
      if (window.confirm("Are you sure you want to delete this FAQ?")) {
        setFaq(faq.filter((_, i) => i !== index));
      }
    }
    else if (type === "feature") {
      if (window.confirm("Delete this feature?")) {
        setFeature(feature.filter((_, i) => i !== index));
      }
    }
    else {
      if (window.confirm("Are you sure you want to delete this review?")) {
        setReviews(reviews.filter((_, i) => i !== index));
      }
    }
  };

  const handleMove = (index, direction, type) => {
    if (type === "faq") {
      if (direction === "up" && index === 0) return;
      if (direction === "down" && index === faq.length - 1) return;

      const newFaq = [...faq];
      const swapIndex = direction === "up" ? index - 1 : index + 1;
      [newFaq[index], newFaq[swapIndex]] = [newFaq[swapIndex], newFaq[index],
      ];

      setFaq(newFaq);
    }

    if (type === "review") {
      if (direction === "up" && index === 0) return;
      if (direction === "down" && index === reviews.length - 1) return;

      const newReview = [...reviews];
      const swapIndex = direction === "up" ? index - 1 : index + 1;

      [newReview[index], newReview[swapIndex]] = [
        newReview[swapIndex],
        newReview[index],
      ];

      setReviews(newReview);
    }

    if (type === "feature") {

      if (direction === "up" && index === 0) return;
      if (direction === "down" && index === feature.length - 1) return;

      const newFeature = [...feature];
      const swapIndex = direction === "up" ? index - 1 : index + 1;

      [newFeature[index], newFeature[swapIndex]] = [
        newFeature[swapIndex],
        newFeature[index],
      ];

      setFeature(newFeature);
    }

  };

  const handleAboutChange = (field, value) => {
    if (field === 'image' && value) { setPreview(URL.createObjectURL(value)) }
    setAbout((prev) => ({ ...prev, [field]: value }));
  };

  const handleFeatureChange = (index, value) => {
    const newFeature = [...feature];
    newFeature[index].title = value;
    setFeature(newFeature);
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <style>{`
        .quill-editor-wrapper .ql-container {
          min-height: 150px;
          max-height: 500px;
          overflow-y: auto;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          font-size: 15px;
          background-color: #fff;
        }
        .quill-editor-wrapper .ql-toolbar {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          background-color: #f8f9fa;
        }
      `}</style>
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h6 className="comm_page_heading">Content Management System (CMS)</h6>
                  <p className="comm_page_sub_heading">
                    Configure the content for Privacy Policy, Terms & Conditions, and edit the FAQ section dynamically.
                  </p>
                </div>
              </div>

              <div className="upper-mian-tabs-comn mt-4">
                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                  <Tab eventKey="privacy" title="Privacy Policy">
                    <div className="patient_referral_form mt-3">
                      <div className="comm_border_box">
                        <Form className="comm_form" onSubmit={(e) => { e.preventDefault(); handleSavePolicy("privacy"); }}>
                          <Form.Group className="comn-class-inputs mb-4">
                            <Form.Label style={{ fontSize: '2rem' }}>Privacy Policy Content</Form.Label>
                            <div className="quill-editor-wrapper">
                              <ReactQuill
                                theme="snow"
                                value={privacyPolicy}
                                onChange={setPrivacyPolicy}
                                modules={modules}
                                formats={formats}
                                placeholder="Write Privacy Policy content..."
                              />
                            </div>
                          </Form.Group>
                          <div className="modal_pair_btns patient_referral_btns">
                            <button type="submit" className="main-btn">Save Privacy Policy</button>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </Tab>

                  <Tab eventKey="terms" title="Terms & Conditions">
                    <div className="patient_referral_form mt-3">
                      <div className="comm_border_box">
                        <Form className="comm_form" onSubmit={(e) => { e.preventDefault(); handleSavePolicy("terms"); }}>
                          <Form.Group className="comn-class-inputs mb-4">
                            <Form.Label style={{ fontSize: '2rem' }}>Terms & Conditions Content</Form.Label>
                            <div className="quill-editor-wrapper">
                              <ReactQuill
                                theme="snow"
                                value={termsConditions}
                                onChange={setTermsConditions}
                                modules={modules}
                                formats={formats}
                                placeholder="Write Terms & Conditions content..."
                              />
                            </div>
                          </Form.Group>
                          <div className="modal_pair_btns patient_referral_btns">
                            <button type="submit" className="main-btn">Save Terms & Conditions</button>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </Tab>

                  <Tab eventKey="faq" title="FAQs Management">
                    <div className="patient_referral_form mt-3">
                      <div className="comm_border_box">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <h5 className="mb-0 fw-bold" style={{ fontSize: '2rem', color: "var(--navy-blue, #0d233a)" }}>Manage Frequently Asked Questions</h5>
                          <button type="button" className="main-outline-btn py-2 px-3" onClick={() => { handleAdd('faq') }} style={{ height: "auto" }}>
                            <FaPlus className="me-2" /> Add FAQ Item
                          </button>
                        </div>
                        {faq.length === 0 ?
                          (<div className="text-center py-5 border border-dashed rounded bg-light">
                            <p className="text-muted mb-3">No FAQ items defined yet.</p>
                            <div className="d-flex justify-content-center">
                              <button type="button" className="main-btn" onClick={() => { handleAdd('faq') }}>
                                Create Your First FAQ
                              </button>
                            </div>
                          </div>)
                          :
                          (<div className="faq-list-builder" style={{ maxHeight: "600px", overflowY: "auto", paddingRight: "10px" }}>
                            {faq.map((item, index) => (
                              <div key={index} className="mb-4 p-4 border rounded position-relative bg-white" style={{ borderColor: "#eef2f5", borderRadius: "12px" }}>
                                <div className="d-flex justify-content-between align-items-start gap-3">
                                  <div className="flex-grow-1">
                                    <Form.Group className="comn-class-inputs mb-3">
                                      <Form.Label>Question {index + 1}</Form.Label>
                                      <Form.Control
                                        type="text"
                                        value={item.question}
                                        onChange={(e) => handleChange(index, "question", e.target.value, 'faq')}
                                        placeholder="Enter the question..."
                                      />
                                    </Form.Group>
                                    <Form.Group className="comn-class-inputs mb-0">
                                      <Form.Label>Answer</Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={item.answer}
                                        onChange={(e) => handleChange(index, "answer", e.target.value, 'faq')}
                                        placeholder="Enter the answer..."
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className="d-flex flex-column gap-2 mt-4">
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm"
                                      disabled={index === 0}
                                      onClick={() => handleMove(index, "up", 'faq')}
                                      title="Move Up"
                                      style={{ width: "32px", height: "32px", padding: 0 }}
                                    >
                                      <FaArrowUp size={12} />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm"
                                      disabled={index === faq.length - 1}
                                      onClick={() => handleMove(index, "down", 'faq')}
                                      title="Move Down"
                                      style={{ width: "32px", height: "32px", padding: 0 }}
                                    >
                                      <FaArrowDown size={12} />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm"
                                      onClick={() => handleDelete(index, 'faq')}
                                      title="Delete FAQ"
                                      style={{ width: "32px", height: "32px", padding: 0 }}
                                    >
                                      <FaTrash size={12} />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          )}
                        {faq.length > 0 && (
                          <div className="modal_pair_btns patient_referral_btns mt-4 border-top pt-3">
                            <button type="button" className="main-btn" onClick={() => handleSave('faq')}>Save FAQs</button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tab>

                  <Tab eventKey="reviews" title="Customer Reviews">
                    <div className="patient_referral_form mt-3">
                      <div className="comm_border_box">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <h5 className="mb-0 fw-bold" style={{ fontSize: '2rem', color: "var(--navy-blue, #0d233a)" }}>Manage Customer reviews</h5>
                          <button type="button" className="main-outline-btn py-2 px-3" onClick={() => { handleAdd('review') }} style={{ height: "auto" }}>
                            <FaPlus className="me-2" /> Add new review
                          </button>
                        </div>
                        {reviews.length === 0 ?
                          (<div className="text-center py-5 border border-dashed rounded bg-light">
                            <p className="text-muted mb-3">No Reviews added yet.</p>
                            <div className="d-flex justify-content-center">
                              <button type="button" className="main-btn" onClick={() => { handleAdd('review') }}>
                                Create first review
                              </button>
                            </div>
                          </div>)
                          :
                          (<div className="faq-list-builder" style={{ maxHeight: "600px", overflowY: "auto", paddingRight: "10px" }}>
                            {reviews.map((item, index) => (
                              <div key={index} className="mb-4 p-4 border rounded position-relative bg-white" style={{ borderColor: "#eef2f5", borderRadius: "12px" }}>
                                <div className="d-flex justify-content-between align-items-start gap-3">
                                  <div className="flex-grow-1">
                                    <Form.Group className="comn-class-inputs mb-3">
                                      <Form.Label>Review {index + 1}</Form.Label>
                                      <Form.Control
                                        type="text"
                                        value={item.review}
                                        onChange={(e) => handleChange(index, "review", e.target.value, 'review')}
                                        placeholder="Enter the review..."
                                      />
                                    </Form.Group>

                                    <Form.Group className="comn-class-inputs mb-3">
                                      <Form.Label>Author</Form.Label>
                                      <Form.Control
                                        type="text"
                                        value={item.author}
                                        onChange={(e) => handleChange(index, "author", e.target.value, 'review')}
                                        placeholder="Enter the author name..."
                                      />
                                    </Form.Group>

                                    <Form.Group className="comn-class-inputs mb-0">
                                      <Form.Label>Address</Form.Label>
                                      <Form.Control
                                        type="text"
                                        value={item.address}
                                        onChange={(e) => handleChange(index, "address", e.target.value, 'review')}
                                        placeholder="Enter the address..."
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className="d-flex flex-column gap-2 mt-4">
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm"
                                      disabled={index === 0}
                                      onClick={() => handleMove(index, "up", "review")}
                                      title="Move Up"
                                      style={{ width: "32px", height: "32px", padding: 0 }}
                                    >
                                      <FaArrowUp size={12} />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm"
                                      disabled={index === faq.length - 1}
                                      onClick={() => handleMove(index, "down", "review")}
                                      title="Move Down"
                                      style={{ width: "32px", height: "32px", padding: 0 }}
                                    >
                                      <FaArrowDown size={12} />
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm"
                                      onClick={() => handleDelete(index, 'review')}
                                      title="Delete FAQ"
                                      style={{ width: "32px", height: "32px", padding: 0 }}
                                    >
                                      <FaTrash size={12} />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          )}
                        {faq.length > 0 && (
                          <div className="modal_pair_btns patient_referral_btns mt-4 border-top pt-3">
                            <button type="button" className="main-btn" onClick={() => handleSave('review')}>Save Reviews</button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="about" title="About Section">
                    <div className="patient_referral_form mt-3">
                      <div className="comm_border_box">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <h5 className="mb-0 fw-bold" style={{ fontSize: '2rem', color: "var(--navy-blue, #0d233a)" }}>About Section</h5>
                        </div>
                        <div className="d-flex justify-content-between align-items-start gap-3">
                          <div className="flex-grow-1">
                            <Form.Group className="comn-class-inputs mb-3">
                              <Form.Label>Title</Form.Label>
                              <Form.Control
                                type="text"
                                value={about.heading}
                                onChange={(e) => handleAboutChange("heading", e.target.value)}
                                placeholder="Enter the heading..."
                              />
                            </Form.Group>

                            <Form.Group className="comn-class-inputs mb-3">
                              <Form.Label>About you</Form.Label>
                              <div className="quill-editor-wrapper">
                                <ReactQuill
                                  theme="snow"
                                  value={about.description}
                                  onChange={(value) => handleAboutChange("description", value)}
                                  modules={modules}
                                  formats={formats}
                                  placeholder="Enter description..."
                                />
                              </div>
                            </Form.Group>

                            <Form.Group className="comn-class-inputs mb-0">
                              <Form.Label>Image</Form.Label>
                              <Form.Control
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleAboutChange("image", e.target.files[0])}
                              />
                            </Form.Group>
                            {preview && (
                              <div className="mt-2">
                                <img
                                  src={preview}
                                  alt="Preview"
                                  style={{
                                    width: "200px",
                                    height: "200px",
                                    objectFit: "contain",
                                    border: "1px solid #ddd",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="modal_pair_btns patient_referral_btns mt-4">
                          <button type="button" className="main-btn" onClick={() => handleSave('about')}>Save About Section</button>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="feature" title="Key Features">
                    <div className="patient_referral_form mt-3">
                      <div className="comm_border_box">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <h5 className="mb-0 fw-bold" style={{ fontSize: "2rem", color: "var(--navy-blue, #0d233a)" }}>Manage Key Features</h5>
                          <button type="button" className="main-outline-btn py-2 px-3" onClick={() => handleAdd("feature")}>
                            <FaPlus className="me-2" /> Add Feature
                          </button>
                        </div>

                        {feature.length === 0 ? (
                          <div className="text-center py-5 border rounded bg-light">
                            <button className="main-btn" onClick={() => handleAdd("feature")}>Create First Feature</button>
                          </div>)
                          :
                          feature.map((item, index) => (
                            <div key={index} className="mb-4 p-4 border rounded bg-white">
                              <Form.Group className="comn-class-inputs mb-3">
                                <Form.Label>Feature {index + 1}</Form.Label>

                                <div className="quill-editor-wrapper">
                                  <ReactQuill
                                    theme="snow"
                                    value={item.title}
                                    onChange={(value) => handleFeatureChange(index, value)}
                                    modules={modules}
                                    formats={formats}
                                    placeholder="Enter feature..."
                                  />
                                </div>
                              </Form.Group>

                              <div className="d-flex gap-2">
                                <button className="btn btn-outline-secondary" disabled={index === 0} onClick={() => handleMove(index, "up", "feature")}><FaArrowUp /></button>
                                <button className="btn btn-outline-secondary" disabled={index === feature.length - 1} onClick={() => handleMove(index, "down", "feature")}><FaArrowDown /></button>
                                <button className="btn btn-outline-danger" onClick={() => handleDelete(index, "feature")}><FaTrash /></button>
                              </div>
                            </div>
                          ))
                        }

                        {feature.length > 0 && (
                          <div className="mt-4">
                            <button className="main-btn" onClick={() => handleSave("feature")}>Save Features</button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default CmsManagement;
